"use client"
import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { usePathname } from "next/navigation"
import { FC, Suspense, useEffect, useRef } from "react"
import { Desktop } from "../../common/bit/MediaQueries"
import Analytics from "../Analytics"
import Footer from "./Footer"
import Header from "./Header"

// Font stack using Next.js LocalFont:
// - --simpler-pro: Hebrew + Numbers ONLY (has unicode-range in declarations)
// - --helvetica: Everything else (no unicode-range)
// Both font classNames applied to body to force Next.js to load both fonts
const FONT_STACK = "var(--simpler-pro), var(--helvetica), sans-serif"

const StyledMain = styled.div<{ isParking: boolean; isContent: boolean }>`
  :focus {
    outline: 0;
  }

  /* When header/footer are hidden, remove padding */
  body.no-layout & {
    padding-top: 0;
    padding-bottom: 0;
  }
  font-family: ${FONT_STACK} !important;
  * {
    font-family: ${FONT_STACK} !important;
  }
`

const StyledHeaderWrapper = styled.div`
  font-family: ${FONT_STACK} !important;
  * {
    font-family: ${FONT_STACK} !important;
  }

  /* Hide header when body has no-layout class */
  body.no-layout & {
    display: none;
  }
`

const StyledFooterWrapper = styled.div`
  font-family: ${FONT_STACK} !important;
  * {
    font-family: ${FONT_STACK} !important;
  }

  margin-top: 64px;

  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 96px;
  }

  body.no-layout & {
    display: none;
  }
`

const StyledButton = styled(Button)`
  position: fixed;
  z-index: -10;
  background-color: black;
  color: white;
  top: -100px;
  &:focus-visible {
    z-index: 9999999;
    top: 0px;
  }
`

const PortLayout: FC<any> = ({
  locale,
  children,
  menu_data,
  header_data,
  footer_data,
  path,
  id,
  searchRoute,
  companyName,
  subcompany,
  projectType,
}) => {
  const mainRef = useRef<HTMLDivElement>(null)
  const pathname = usePathname()

  const handleClick = () => {
    if (mainRef.current) {
      mainRef.current.focus()
    }
  }

  useEffect(() => {
    // Dispatch route-change-callbox event whenever pathname changes
    const event = new CustomEvent("route-change-callbox", {
      detail: {
        pathname,
        timestamp: new Date().getTime(),
      },
    })
    document.dispatchEvent(event)
  }, [pathname])
  return (
    <>
      <Suspense>
        <Analytics
          companyName={companyName}
          locale={locale}
          subcompany={subcompany}
          projectType={projectType}
        />
      </Suspense>
      <StyledHeaderWrapper>
        <Desktop>
          <StyledButton id="skip-to-content" tabIndex={3} onClick={handleClick}>
            {locale === "he" ? "דלג לתוכן המרכזי" : "skip navigation"}
          </StyledButton>
        </Desktop>

        <Header
          header_data={header_data}
          data={menu_data}
          locale={locale}
          path={path}
          id={id}
          searchRoute={searchRoute}
          companyName={companyName}
        />
      </StyledHeaderWrapper>
      {/* <Cookies /> */}

      <>
        <StyledMain
          isContent={pathname.includes("content")}
          isParking={pathname === "/parking" || pathname === "/en/parking"}
          id="mainContent"
          tabIndex={-1}
          ref={mainRef}
          role="main"
        >
          {children}
        </StyledMain>
        {footer_data && (
          <StyledFooterWrapper>
            <Footer data={footer_data} companyName={companyName} locale={locale} />
          </StyledFooterWrapper>
        )}
      </>
    </>
  )
}

export default PortLayout
